import type { FC } from 'react'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import classNames from 'classnames'
import { Button, Image } from '@/components/ui'
import { RadioButton } from '@/components/ui/ReactHookFormFields'
import type { IAgentRegistrationRequestFormValues } from '@/types/IAgentRegistrationRequestFormValues'
import { EAgentRegistrationCommunicationMethod } from './constants'
import { messages } from './messages'
import type { IAgentRegistrationCommunicationMethodProps } from './types'
import './styles.scss'

export const AgentRegistrationCommunicationMethod: FC<IAgentRegistrationCommunicationMethodProps> = props => {
  const { onSubmit, isLoading } = props

  const { control, watch } = useFormContext<IAgentRegistrationRequestFormValues>()
  const communicationMethodField = watch('communicationMethod')

  return (
    <div className="agentRegistrationCommunicationMethod">
      <h3 className="agentRegistrationCommunicationMethod__title">{messages.title}</h3>
      <div className="agentRegistrationCommunicationMethod__wrapper">
        <div
          className={classNames('agentRegistrationCommunicationMethod__card', {
            'agentRegistrationCommunicationMethod__card--selected':
              communicationMethodField === EAgentRegistrationCommunicationMethod.CALL_PHONE,
          })}
        >
          <Image className="agentRegistrationCommunicationMethod__image" src="financingOffer/agent/connections/phone.png" isInStatic />
          <RadioButton
            className="agentRegistrationCommunicationMethod__radioButton"
            name="communicationMethod"
            control={control}
            value={EAgentRegistrationCommunicationMethod.CALL_PHONE}
            CustomLabel={<h5>{messages.fields.communicationMethod.phone}</h5>}
          />
        </div>
        <div
          className={classNames('agentRegistrationCommunicationMethod__card', {
            'agentRegistrationCommunicationMethod__card--selected':
              communicationMethodField === EAgentRegistrationCommunicationMethod.EMAIL,
          })}
        >
          <Image className="agentRegistrationCommunicationMethod__image" src="financingOffer/agent/connections/email.png" isInStatic />
          <RadioButton
            className="agentRegistrationCommunicationMethod__radioButton"
            name="communicationMethod"
            control={control}
            value={EAgentRegistrationCommunicationMethod.EMAIL}
            CustomLabel={<h5>{messages.fields.communicationMethod.email}</h5>}
          />
        </div>
      </div>

      <div className="communicationMethodSelector__actions">
        <Button
          modifiers={['green', 'full-width-mobile']}
          loaderProps={{ isVisible: isLoading }}
          onClick={onSubmit}
          isDisabled={!communicationMethodField}
        >
          {messages.actions.select}
        </Button>
      </div>
    </div>
  )
}
